import apiClient from "@/services/axios";
import { mapState } from "vuex";
import { showApiError } from "@/utilities/showApiError";
import MarkHistoryModal from "../components/MarkHistoryModal.vue";

export default {
  components: {
    MarkHistoryModal,
  },
  data() {
    return {
      markHistoryVisible: false,
      markHistoryLoading: false,
      markHistoryRows: [],
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    canViewGradeHistory() {
      const building = this.user?.building?.find(
        (b) => b.dbName === this.settings.activeBuilding
      );
      return Boolean(building?.pack?.access?.edManager?.viewGradeHistory);
    },
  },
  methods: {
    closeMarkHistory() {
      this.markHistoryVisible = false;
      this.markHistoryRows = [];
    },
    async openMarkHistory({ student, subject, subsubject, divided }) {
      if (!this.canViewGradeHistory) return;
      if (!this.selectedClasse || !this.selectedTrimester || !student || !subject) {
        return;
      }
      this.markHistoryVisible = true;
      this.markHistoryLoading = true;
      this.markHistoryRows = [];
      try {
        const params = {
          trimester: this.selectedTrimester,
          student,
          subject,
          classroom: this.selectedClasse,
        };
        if (divided && subsubject) {
          params.subsubject = subsubject;
        }
        const { data } = await apiClient.get("/bulletin/v2/mark/history", {
          params,
        });
        this.markHistoryRows = data || [];
      } catch (err) {
        showApiError(this, err);
        this.markHistoryVisible = false;
      } finally {
        this.markHistoryLoading = false;
      }
    },
  },
};
